let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8ZN0s")).then(() => parcelRequire('ezGM7'));